import React from 'react';
import { CheckCircle, Award, Users, Clock } from 'lucide-react';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-hero-title">About Genuine Fencers</h1>
          <p className="page-hero-subtitle">
            Sydney's trusted name in premium glass fencing and balustrades
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="about-story-section">
        <div className="container">
          <div className="about-story-grid">
            <div className="about-story-content">
              <h2 className="about-story-title">Our Story</h2>
              <p className="about-story-text">
                Genuine Fencers has been serving the Sydney community with premium glass fencing and balustrade solutions. 
                We pride ourselves on delivering exceptional quality, professional service, and stunning results that transform properties.
              </p>
              <p className="about-story-text">
                Our team of experienced professionals is dedicated to providing frameless and semi-frameless glass installations 
                that not only meet but exceed Australian safety standards. We understand that your property is your biggest investment, 
                and we treat every project with the care and attention it deserves.
              </p>
              <p className="about-story-text">
                From initial consultation to final installation, we work closely with our clients to ensure their vision becomes reality. 
                Our commitment to quality materials, expert craftsmanship, and customer satisfaction has made us a trusted name across Sydney.
              </p>
            </div>
            <div className="about-story-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_frameless-fencing/artifacts/ueziz642_WhatsApp%20Image%202026-04-06%20at%207.43.33%20PM.jpeg" 
                alt="Genuine Fencers Work" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-values-section">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <Award className="value-icon" size={40} />
              <h3>Quality First</h3>
              <p>We never compromise on quality. Premium materials, expert installation, and meticulous attention to detail in every project.</p>
            </div>
            <div className="value-card">
              <Users className="value-icon" size={40} />
              <h3>Customer Focus</h3>
              <p>Your satisfaction is our priority. We listen, advise, and deliver solutions that perfectly match your needs and vision.</p>
            </div>
            <div className="value-card">
              <CheckCircle className="value-icon" size={40} />
              <h3>Reliability</h3>
              <p>On-time completion, transparent communication, and guaranteed workmanship. You can count on us.</p>
            </div>
            <div className="value-card">
              <Clock className="value-icon" size={40} />
              <h3>Efficiency</h3>
              <p>Professional project management ensures minimal disruption and timely completion without sacrificing quality.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="about-stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">100+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">100%</div>
              <div className="stat-label">Standards Compliant</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">5 Star</div>
              <div className="stat-label">Customer Rating</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">Sydney Wide</div>
              <div className="stat-label">Service Coverage</div>
            </div>
          </div>
        </div>
      </section>

      {/* Commitment Section */}
      <section className="commitment-section">
        <div className="container">
          <div className="commitment-content">
            <h2>Our Commitment to You</h2>
            <div className="commitment-list">
              <div className="commitment-item">
                <CheckCircle size={24} />
                <div>
                  <h3>Licensed & Insured</h3>
                  <p>Fully licensed professionals with comprehensive insurance coverage for your peace of mind.</p>
                </div>
              </div>
              <div className="commitment-item">
                <CheckCircle size={24} />
                <div>
                  <h3>Australian Standards</h3>
                  <p>All installations meet or exceed AS 1926.1-2012 requirements for pool fencing and balustrades.</p>
                </div>
              </div>
              <div className="commitment-item">
                <CheckCircle size={24} />
                <div>
                  <h3>Quality Materials</h3>
                  <p>12mm toughened safety glass and marine-grade stainless steel hardware for durability and safety.</p>
                </div>
              </div>
              <div className="commitment-item">
                <CheckCircle size={24} />
                <div>
                  <h3>Warranty Backed</h3>
                  <p>Comprehensive warranties on materials and workmanship to protect your investment.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
